/*
 * @Author: yanyongchao
 * @Date: 2018-12-30 23:41:49
 * @Last Modified by: yanyongchao
 * @Last Modified time: 2019-01-10 22:18:06
 */
import md5 from './md5'
import store from 'store'

export const getBody = (obj) => {
  if (obj) {
    delete obj.sign
  }
  const body = JSON.stringify(obj)
  let token = (store.getters.accessToken && store.getters.accessToken.length) ? store.getters.accessToken : localStorage.getItem('access_token')
  const sign = md5((obj ? body : '') + token + process.env.VUE_APP_PHP_SERVE_KEY)
  obj = obj || {}
  obj.sign = sign
  return obj
}

export const getParam = (obj) => {
  const body = JSON.stringify(obj)
  const sign = md5((obj ? body : '') + localStorage.getItem('access_token') + process.env.VUE_APP_PHP_SERVE_KEY)
  obj = obj || {}
  obj.sign = sign
  return obj
}
